import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../../environments/environment';
import { SettingsService } from '../services/settings-service/settings.service';

/**
 * Modal component that displays version changes and known issues after an app update.
 * Shown automatically after updates or can be manually triggered from the menu.
 */
@Component({
	selector: 'app-update-notification-modal',
	standalone: true,
	imports: [CommonModule],
	template: `
		<div class="modal-header bg-primary text-white mb-3">
			<h4 class="modal-title">Päivitystiedot - {{ settingsService.AppVersionWithPostfix }}</h4>
			<button
				type="button"
				class="btn-close btn-close-white"
				aria-label="Sulje"
				(click)="activeModal.dismiss()"
			></button>
		</div>
		<div class="modal-body">
			<p>Tervetuloa MetaPressin uusimpaan versioon!</p>
			<hr>
			<!-- Version Changes Section -->
			<div class="mb-4" *ngIf="versionChangesHtml">
				<h5 class="text-primary mb-3">
					<i class="bi bi-wrench me-1"></i>
					Korjaukset
				</h5>
				<div
					[innerHTML]="versionChangesHtml"
					class="version-content"
				></div>
			</div>

			<!-- Known Issues Section -->
			<div *ngIf="knownIssuesHtml">
				<h5 class="text-primary mb-3">
					<i class="bi bi-exclamation-triangle me-1"></i>
					Tiedossa olevat ongelmat
				</h5>
				<div
					[innerHTML]="knownIssuesHtml"
					class="known-issues-content"
				></div>
			</div>

			<!-- Empty state if no content -->
			<div
				*ngIf="!versionChangesHtml && !knownIssuesHtml"
				class="text-center text-muted py-4"
			>
				<i class="bi bi-info-circle" style="font-size: 3rem;"></i>
				<p class="mt-3">Ei versiotietoja saatavilla.</p>
			</div>
		</div>
		<div class="modal-footer">
			<button
				type="button"
				class="btn btn-primary"
				(click)="activeModal.close()"
			>
				Sulje
			</button>
		</div>
	`,
	styles: [
		`
			.version-content,
			.known-issues-content {
				line-height: 1.6;
			}

			.version-content ul,
			.known-issues-content ul {
				margin-bottom: 0;
			}

			.version-content h5,
			.known-issues-content h5 {
				font-size: 1.1rem;
				margin-bottom: 0.75rem;
			}
		`,
	],
})
export class UpdateNotificationModalComponent {
	// HTML content from environment configuration
	versionChangesHtml: string = environment.versionChangesHtml;
	knownIssuesHtml: string = environment.knownIssuesHtml;

	constructor(
		public activeModal: NgbActiveModal,
		protected settingsService: SettingsService,
	) {}
}
